import React from 'react';

const CreateAppFormContext = React.createContext((() => {}));

export default CreateAppFormContext;



// WEBPACK FOOTER //
// ./src/containers/CreateApp/components/Form/CreateAppFormContext.js